import { ANO_MATRICULA } from './enrollmentYear';
import { getStudentByIDCenso, getResponsables, getResponsableInfo, getEnrollmentContractStatuses } from '../../api/endpoints/sponte';

export const scalar = (value) => String((Array.isArray(value) ? value[0] : value) || '').trim();
const normalize = (value) => scalar(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export function filterEnrollmentStudents(students, input) {
  const terms = normalize(input).split(/\s+/).filter(Boolean);
  return students.filter((student) => {
    const name = normalize(student.Aluno);
    return terms.every((term) => name.includes(term));
  }).slice(0, 50);
}

function responsibleIds(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.flatMap(responsibleIds);
  if (value.wsResponsaveis) return responsibleIds(value.wsResponsaveis);
  const id = scalar(value.ResponsavelID || value.id);
  return id ? [id] : [];
}

export async function loadEnrollmentStudent(student, signal) {
  const options = { signal, timeout: 40000 };
  const [data, local] = await Promise.all([
    getStudentByIDCenso(student.AlunoID, options),
    getEnrollmentContractStatuses(ANO_MATRICULA, [student.AlunoID], options)
      .then(rows => ({ status: rows.find(row => scalar(row.studentExternalId || row.AlunoID) === String(student.AlunoID)) || null }))
      .catch(() => ({ error: true })),
  ]);
  if (signal.aborted) return null;
  if (!data || scalar(data.AlunoID) !== String(student.AlunoID)) {
    throw new Error('Não foi possível obter os dados do aluno selecionado. Tente novamente.');
  }
  let ids = responsibleIds(data.Responsaveis);
  if (!ids.length) {
    ids = responsibleIds(await getResponsables(student.AlunoID, options));
  }
  if (signal.aborted) return null;
  const results = await Promise.all([...new Set(ids)].map((id) =>
    getResponsableInfo(id, student.AlunoID, options)
  ));
  if (signal.aborted) return null;
  if (results.some((result) => !result)) {
    throw new Error('Não foi possível carregar todos os responsáveis. Tente novamente.');
  }
  return { ...data, responsaveisCompletos: results, enrollmentContractStatus: local.status, enrollmentContractStatusError: Boolean(local.error) };
}
